import { render, staticRenderFns } from "./ResultsDaily.vue?vue&type=template&id=f675fd04&"
import script from "./ResultsDaily.vue?vue&type=script&lang=js&"
export * from "./ResultsDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports